import { defineMessages } from "react-intl";

export default defineMessages({
  view: {
    id: "app.components.CardResultStudent.view",
    defaultMessage: "View"
  },
  viewQualify: {
    id: "app.components.CardResultStudent.viewQualify",
    defaultMessage: "View / qualify"
  },
  good: {
    id: "app.components.CardResultStudent.good",
    defaultMessage: "Good"
  },
  answered: {
    id: "app.components.CardResultStudent.answered",
    defaultMessage: "Answered"
  },
  bad: {
    id: "app.components.CardResultStudent.bad",
    defaultMessage: "Bad"
  },
  ommited: {
    id: "app.components.CardResultStudent.ommited",
    defaultMessage: "Ommited"
  },
  notQualified: {
    id: "app.components.CardResultStudent.notQualified",
    defaultMessage: "Not qualified"
  },
  canceled: {
    id: "app.components.CardResultStudent.canceled",
    defaultMessage: "Canceled"
  },
  studentHistoryIconTitle: {
    id: "app.components.CardResultStudent.studentHistoryIconTitle",
    defaultMessage: "Show performance of all assessments"
  },
  qualification: {
    id: "app.components.CardResultStudent.qualification",
    defaultMessage: "Qualification"
  },
  preguntas: {
    id: "app.components.CardResultStudent.preguntas",
    defaultMessage: "Questions"
  },
  contested: {
    id: "app.components.CardResultStudent.contested",
    defaultMessage: "Contested"
  }
});
